import { createContext, useContext, useEffect, useReducer, useState } from "react";

import axios, { axiosClient } from "../../api/axios";
import { LOADED, STATUS_NOT_LOADED } from "../../api/constant";
import { showTypeErrorFetch } from "../../utilities/alerts.utilities"
import { INITIAL_STATE, types, warehouseReducer } from "../../reducers/inventory/warehouseReducer";

export const WarehouseIndexContext = createContext({});

export const WarehouseIndexProvider = ({ children }) => {
  const [state, dispatch] = useReducer(warehouseReducer, INITIAL_STATE);

  const setFieldFormWarehouse = (value, field)=>{
    dispatch({type: types.SET_FIELD_FORM_WAREHOUSE, payload: {value: value, name: field } });
  };

  const goToWarehouseEdit = (item_id)=>{
    dispatch({type: types.SET_EDIT_FORM_WAREHOUSE, payload: true});

    let selectWarehouseItem = state.elements.filter((item) => item.id == item_id);
    dispatch({type: types.EDIT_FORM_WAREHOUSE, payload: selectWarehouseItem[0] });
  }
  

  useEffect(() => {
    if (state.status == STATUS_NOT_LOADED) {
      axios()
      .get(`inventory/getListWarehouses`,{ 
        params: state.filter,
      })
      .then(({ data }) => {
            dispatch({
              type: types.WAREHOUSES_LOADED,
              payload: { elements: data.warehouses, rows: data.rows },
            });
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
    }
    
  }, [state.status]);
  
  const createWarehouseClick = ()=>{
    axios()
      .post(`inventory/createWarehouse`, {
        name: state.edit_warehouse.name,
        code: state.edit_warehouse.code,
        laboratory_id: 1
      })
      .then(({ data }) => {
        dispatch({
          type: types.RELOAD_INDEX_WAREHOUSES,
        });
        dispatch({type: types.EDIT_FORM_WAREHOUSE, payload: INITIAL_STATE.edit_warehouse });
        dispatch({type: types.SET_EDIT_FORM_WAREHOUSE, payload: false});
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  }

  const editWarehouseClick = ()=>{
    axios()
      .put(`inventory/editWarehouse/${state.edit_warehouse.id}`, {
        name: state.edit_warehouse.name,
        code: state.edit_warehouse.code,
      })
      .then(({ data }) => {
        dispatch({
          type: types.RELOAD_INDEX_WAREHOUSES,
        });
        dispatch({type: types.EDIT_FORM_WAREHOUSE, payload: INITIAL_STATE.edit_warehouse });
        dispatch({type: types.SET_EDIT_FORM_WAREHOUSE, payload: false});
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  }

  return (
    <WarehouseIndexContext.Provider 
    value={[
      state,
      dispatch,
      {
        setFieldFormWarehouse, createWarehouseClick, goToWarehouseEdit, editWarehouseClick 
      },
    ]}
      >
      {children}
    </WarehouseIndexContext.Provider>
  );
}
const useWarehouse = () => useContext(WarehouseIndexContext)[0];
const useDispatchWarehouseIndex = () => useContext(WarehouseIndexContext)[1];
const useActionsWarehouseIndex = () => useContext(WarehouseIndexContext)[2];

export {
  useWarehouse,
  useDispatchWarehouseIndex,
  useActionsWarehouseIndex,
};

